import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/acms/security_locations',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: '/acms/security_location/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/acms/security_locations/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/acms/security_locations',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/acms/security_locations/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/acms/security_locations/${id}`,
      method: 'delete',
  })
}
